import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-arrow-down',
    templateUrl: './arrow-down.component.svg',
    styleUrls: ['./arrow-down.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowDownComponent {}
